import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Input, Select, StatusBadge } from "@/components/kmt/ui";
import { useLoad, useOwnerApi } from "@/lib/api";
import { SERVICE_LABEL, STAGES, TERMINAL, ct, prettyPhone, usd } from "@/lib/format";
import { PageTitle } from "./DashLayout";

const FILTERS = [{ value: "", label: "All stages" }, ...STAGES, ...TERMINAL];

export default function Bookings() {
  const api = useOwnerApi();
  const [params, setParams] = useSearchParams();
  const status = params.get("status") || "";
  const [q, setQ] = useState("");
  const { data, error } = useLoad(() => api.get("/bookings", { params: { status: status || undefined, q: q || undefined } }).then((r) => r.data), [api, status, q]);
  return (
    <div>
      <PageTitle title="Bookings" sub="All times Central">
        <Link to="/dashboard/new" className="inline-flex min-h-[48px] items-center rounded-full bg-plum px-6 font-medium transition-colors duration-200 hover:bg-orchid" data-testid="bookings-add-btn">Add ride</Link>
      </PageTitle>
      <div className="mb-6 grid gap-3 md:grid-cols-[240px_1fr]">
        <Select aria-label="Filter by stage" options={FILTERS} value={status} onChange={(e) => setParams(e.target.value ? { status: e.target.value } : {})} data-testid="bookings-status-filter" />
        <Input aria-label="Search" placeholder="Search name, phone or ref" value={q} onChange={(e) => setQ(e.target.value)} data-testid="bookings-search" />
      </div>
      {error && <p className="text-red-200">{error}</p>}
      <div className="overflow-x-auto rounded-md border border-gold/20">
        <table className="w-full min-w-[760px] text-left text-[15px]" data-testid="bookings-table">
          <thead className="bg-aubergine text-[14px] text-gold">
            <tr><th className="p-4 font-medium">Ref</th><th className="p-4 font-medium">Customer</th><th className="p-4 font-medium">Pickup</th><th className="p-4 font-medium">Service</th><th className="p-4 font-medium">Total</th><th className="p-4 font-medium">Stage</th></tr>
          </thead>
          <tbody className="divide-y divide-gold/10">
            {(data || []).map((b: any) => (
              <tr key={b.id} className="transition-colors duration-200 hover:bg-white/5">
                <td className="p-4"><Link to={`/dashboard/bookings/${b.id}`} className="inline-flex min-h-[48px] items-center text-gold hover:underline" data-testid={`booking-link-${b.ref}`}>{b.ref}</Link></td>
                <td className="p-4">{b.name}<br /><span className="text-[14px] text-mist/65">{prettyPhone(b.phone)}</span></td>
                <td className="p-4">{ct(b.pickup_at)}</td>
                <td className="p-4">{SERVICE_LABEL[b.service]}</td>
                <td className="p-4">{usd(b.total)}</td>
                <td className="p-4"><StatusBadge status={b.status} label={b.status_label} /></td>
              </tr>
            ))}
            {data && !data.length && <tr><td colSpan={6} className="p-6 text-mist/60" data-testid="bookings-empty">No bookings found.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
